export const HasOutstandingXhrCallsEventKey = 'NoOfOutstandingXhrCallsEventKey';
export const MobileFacetsUpdateEventKey = 'MobileFacetsUpdateEventKey';
export const RouterBeforeChangeKey = 'RouterBeforeChangeKey';
export const potentialMaintenanceMaxFailedRequestLimit = 4;
export const potentialMaintenanceMaxFailedRequestLimitReachedKey = 'potentialMaintenanceMaxFailedRequestLimitReachedKey';
